export enum inputTypes {
  ExtraAnalysis = 'ExtraAnalysis',
  ManualInput = 'ManualInput'
}